const alert = document.getElementById('alert__wrapper')

if (alert) {
    const close = document.getElementsByClassName('alert__close')[0]

    close.addEventListener('click', () => {
        alert.classList.add('hide')

        // adding cookie to expire in 1day
        const now = new Date()
        now.setTime(now.getTime() + 1 * 24 * 3600 * 1000)
        document.cookie = 'information=global-website-information; expires='
            + now.toUTCString() + '; path=/'
    })
}
